import { authService } from "../../services/authService";

const Navbar = () => {

  const logoutAsync = async () => {
    try {
      var response=await authService.logoutAsync();
      if(response.isSuccess){
        window.location.href="/";
        return;
      }
    } catch (error) {
      console.log(error);
    }
  }
    return (
      <>
        <input
          id="aside-toggle-checkbox"
          class="aside-toggle-checkbox"
          type="checkbox"
        />
        <label htmlFor="aside-toggle-checkbox" className="aside-toggle-layer" />
        <div className="my-navbar">
          <nav className="navbar navbar-expand-lg navbar-white navbar-light">
            <div class="container-fluid">
              <label
                htmlFor="aside-toggle-checkbox"
                className="cursor-pointer fas fa-bars aside-toggle"
              />
              <ul class="navbar-nav">
                <li class="nav-item">
                  <a class="nav-link active" href="#" onClick={logoutAsync}>
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </>
    );
}

export default Navbar